module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta4.2a10de32.jpg";